import React from 'react';
import { Globe } from 'lucide-react';

interface SEOPreviewProps {
  url: string;
  title: string;
  description: string;
  imageUrl?: string;
}

const SEOPreview: React.FC<SEOPreviewProps> = ({ url, title, description, imageUrl }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 space-y-3">
      <h3 className="text-sm font-medium text-gray-700 mb-2">Aperçu SEO</h3>
      
      {/* Google Preview */}
      <div className="border-b border-gray-200 pb-4">
        <h4 className="text-xs font-medium text-gray-600 mb-2 flex items-center">
          <Globe className="w-4 h-4 mr-1" />
          Aperçu Google
        </h4>
        <div className="space-y-1">
          <p className="text-[#1a0dab] text-xl hover:underline cursor-pointer">
            {title || 'Titre de la page'}
          </p>
          <p className="text-[#006621] text-sm">
            {url}
          </p>
          <p className="text-sm text-gray-600 line-clamp-2">
            {description || 'Ajoutez une meta description pour améliorer votre référencement...'}
          </p>
        </div>
      </div>

      {/* Social Media Preview */}
      {imageUrl && (
        <div className="pt-2">
          <h4 className="text-xs font-medium text-gray-600 mb-2">
            Aperçu réseaux sociaux
          </h4>
          <div className="border border-gray-200 rounded overflow-hidden">
            <img 
              src={imageUrl} 
              alt="Social preview" 
              className="w-full h-40 object-cover"
            />
            <div className="p-3 bg-gray-50">
              <p className="font-medium text-sm text-gray-900 mb-1">{title}</p>
              <p className="text-sm text-gray-600 line-clamp-2">{description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SEOPreview;